import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { userById } from './types';
import { requestUserByIdSuccess, requestUserByIdFailure } from './actions';

const logger = new Logger('Saga:UserList');

export function* requestUserByIdSaga(action) {
  const routerService = yield getContext('routerService');
  const authApiService = yield getContext('authApiService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.get_user', {
        id: action.id,
      }),
    );

    yield put(requestUserByIdSuccess(response.data));
  } catch (error) {
    logger.error('Failed to get user by id', error);
    yield put(requestUserByIdFailure(error));
  }
}

export default function* marketplaceSaga() {
  return yield all([takeLatest(userById.request, requestUserByIdSaga)]);
}
